import { render, staticRenderFns } from "./ExchangesPage.vue?vue&type=template&id=4af0ff2a&"
import script from "./ExchangesPage.vue?vue&type=script&lang=js&"
export * from "./ExchangesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports